<div class="search-wrapper">
  <div #searchContainer (click)="focusInput()" (mouseenter)="setHover(true)" (mouseleave)="setHover(false)"
    [ngClass]="{'search-container': true, 'search-container-focus': isFocused}">
    <div class="search-box-wrapper">
      <div class="search-icon-wrapper">
        <img class="search-icon"
          src="./../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,630,24,24))" />
      </div>
      <div class="search-box" *ngIf="suggestion">
        <div *ngFor="let item of selectedItems ; let i = index">
          <div class="selected-items" *ngIf="i < 1">{{item}}
            <img src="../../../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,30,24,24))" style="height: 17px;
            width: 17px; margin: 0 0 4px 0;" (click)="removeItem(item, $event)">
          </div>
        </div>
        <span *ngIf="selectedItems.length > 1" 
          class="selected-items" title="{{selectedItems}}">+ {{selectedItems.length - 1}}</span>
        <div class="input-wrapper">
          <input #searchBox class="search-input" [placeholder]="configData.placeHolder | translate" type="text" on-focus="setFocus(true)"
            (focusout)="setFocus(false)" (keyup.enter)="onselect($event)" (keyup.backspace)="onBackspace($event)"
            (paste)="onPaste($event)" (keyup)="search($event)" [attr.minlength]="configData.minSearchCharLen" *ngIf="isEnableFilterSearch"/>
          <input *ngIf="!isEnableFilterSearch" #searchBox class="search-input" [placeholder]="configData.placeHolder | translate" type="text"
            on-focus="setFocus(true)" (focusout)="setFocus(false)"
            (keyup.enter)="onselect($event)" (keyup)="search($event)" [attr.minlength]="configData.minSearchCharLen" />
          </div> 
        </div>
        <div class="input-wrapper" *ngIf="!suggestion">
          <input #searchBox class="search-input" [placeholder]="configData.placeHolder | translate" type="text"
            on-focus="setFocus(true)" (focusout)="setFocus(false)" (keyup.enter)="onselect($event)" (keyup)="search($event)" (keyup.backspace)="onBackspace($event)"
            (paste)="onPaste($event)" [attr.minlength]="configData.minSearchCharLen" *ngIf="isEnableFilterSearch"/>
          <input *ngIf="!isEnableFilterSearch" #searchBox class="search-input" [placeholder]="configData.placeHolder | translate" type="text"
          on-focus="setFocus(true)" (focusout)="setFocus(false)" (keyup.enter)="onselect($event)"
          (keyup)="search($event)" [attr.minlength]="configData.minSearchCharLen" />
          </div>
      <div class="cancel" *ngIf="(searchValue || selectedItems.length > 0)"><img
          src="../../../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,30,24,24))" (click)="close($event)" />
      </div>
    </div>

    <div *ngIf="configData.showSuggestion !== false && suggestion && flag && (suggestionList )?.length > 0 && searchValue?.length >= 3" class="search-result">
      <hr />
      <div *ngIf="(suggestionList)?.length > 0" class="search-history-wrapper">
        <label class="search-history-label">Suggestions</label>
      </div>
      <div class="suggestion-list" *ngFor="let suggestion of suggestionList ">
        <img style="height: 20px; width: 20px;"
          src="./../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,630,24,24))">
        <a class="list-items" (click)="onselect( $event,suggestion)" [innerHTML]="suggestion | textHighlight: searchValue"></a>
          <div class="secondary-label"  [innerHTML]="suggestion | textHighlight: searchValue"></div>
      </div>
    </div>
    <div *ngIf="history && flag && (historyList)?.length > 0 && searchValue?.length < 3" class="search-result">
      <hr />
      <div *ngIf="(historyList)?.length > 0">
        <div class="search-history-wrapper">
          <label class="search-history-label">History</label>
          <img class="clearHistory" title="clear search history"
            src="../../../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,30,24,24))"
            (click)="clearHistory()">
        </div>
        <div class="history-list" *ngFor="let history of historyList">
          <img style="height: 20px; width: 20px;"
            src="./../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,1500,48,48))">
          <a class="list-items" (click)="onselect( $event,history)">{{history}}
            <div class="secondary-label">{{history}}</div>
          </a>
        </div>
      </div>
    </div>
  </div>
  <div class="form-field-error" *ngIf="hasSearchError">
    <span class="error-icon">
        <img class="dhl-input-error-icon" src="../../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,60,24,24))">
    </span>
    <span class="error-text">
        {{errorMessage | translate}}
    </span>
  </div>
</div>